import { changeLanguage } from "@i18n/i18n";
import {
  Dialog,
  DialogContent,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Box,
  Typography
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export interface LanguageDialogProps {
  open: boolean;
  onClose: () => void;
}

const languages = [
  { code: "ca" as const, label: "Català" },
  { code: "es" as const, label: "Castellano" },
  { code: "en" as const, label: "English" }
];

const LanguageDialog: React.FC<LanguageDialogProps> = ({ open, onClose }) => {
  const { t, i18n: i18nInstance } = useTranslation();
  const [tempLanguage, setTempLanguage] = useState<"es" | "en" | "ca">(
    (i18nInstance.language as "es" | "en" | "ca") || "ca"
  );

  // Update temp language when dialog opens or i18n language changes
  useEffect(() => {
    if (open) {
      setTempLanguage((i18nInstance.language as "es" | "en" | "ca") || "ca");
    }
  }, [open, i18nInstance.language]);

  const handleAccept = () => {
    changeLanguage(tempLanguage);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 3,
          minWidth: { xs: "90%", sm: 320 },
          maxWidth: { xs: "90%", sm: 400 }
        }
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Typography
          sx={{
            fontFamily: "Ringside Narrow",
            fontWeight: 325,
            fontSize: "14px",
            lineHeight: "18px",
            letterSpacing: "0%",
            color: "#000000",
            textTransform: "uppercase",
            mb: 2
          }}
        >
          {t("navbar.languages", "IDIOMA")}
        </Typography>

        <RadioGroup
          value={tempLanguage}
          onChange={(e) =>
            setTempLanguage(e.target.value as "es" | "en" | "ca")
          }
          sx={{ mb: 3 }}
        >
          {languages.map((lang) => (
            <FormControlLabel
              key={lang.code}
              value={lang.code}
              control={
                <Radio
                  sx={{
                    color: "#000000",
                    "&.Mui-checked": {
                      color: "#000000"
                    }
                  }}
                />
              }
              label={
                <Typography
                  sx={{
                    fontFamily: "Ringside Narrow",
                    fontWeight: 325,
                    fontSize: "16px",
                    lineHeight: "20px",
                    letterSpacing: "0%",
                    color: "#000000"
                  }}
                >
                  {lang.label}
                </Typography>
              }
              sx={{
                mb: 1,
                "& .MuiFormControlLabel-label": {
                  ml: 1
                }
              }}
            />
          ))}
        </RadioGroup>

        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            onClick={handleAccept}
            sx={{
              fontFamily: "Ringside Narrow",
              fontWeight: 325,
              fontSize: "14px",
              lineHeight: "18px",
              letterSpacing: "0%",
              color: "#000000",
              textTransform: "none",
              "&:hover": {
                bgcolor: "rgba(0, 0, 0, 0.04)"
              }
            }}
          >
            {t("navbar.language.accept", "Aceptar")}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LanguageDialog;
